import mitt from "mitt";

// 创建全局事件总线
const eventBus = mitt();

// 常用事件类型常量
export const EVENT_TYPES = {
	LOGIN_SUCCESS: "login-success",
	THIRD_PARTY_NEEDS_BIND_EMAIL: "third-party-needs-bind-email",
	LOGOUT: "logout",
	USER_INFO_UPDATED: "user-info-updated",
	NOTIFICATION: "notification",
	PAYMENT_SUCCESS: "payment-success",
	OPEN_USER_CENTER_DRAWER: "open-user-center-drawer",
};

export default eventBus;
